import { render, staticRenderFns } from "./AddNewDealerType.vue?vue&type=template&id=93019790&"
import script from "./AddNewDealerType.vue?vue&type=script&lang=ts&"
export * from "./AddNewDealerType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports